<template>
	<div class="c-checklist-media-block__container" ref="container">
		<div class="c-checklist-media-block__guide-box">
			<div class="c-checklist-media-block__mkb-bo" ref="mkbBo">
				<slot name="default">
					<VChecklistPopupModal />
				</slot>
				<img
					src="/gui/images/checklist-items/mkb-bo-cyckel.svg"
					alt="bo på cyckel"
					aria-hidden="true"
				/>
			</div>
		</div>
		<div class="c-checklist-media-block__background">
			<div class="c-checklist-media-block__start">
				<img
					src="/gui/images/checklist-items/mkb-flyttboxar.svg"
					alt="flyttboxar"
					aria-hidden="true"
				/>
			</div>
			<div class="c-checklist-media-block__road" ref="road">
				<img
					src="/gui/images/checklist-items/mkb-dash-linje.svg"
					alt="linje"
					aria-hidden="true"
					:style="getRoadImageStyle"
				/>
			</div>
			<div class="c-checklist-media-block__end" ref="end">
				<img
					src="/gui/images/checklist-items/mkb-hus.svg"
					alt="hus"
					aria-hidden="true"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import VChecklistPopupModal from "./VChecklistPopupModal.vue";

export default {
	name: "VChecklistMediaBlock",

	components: {
		VChecklistPopupModal
	},

	data() {
		return {
			windowWidth: 0,
			containerHeight: 0,
			containerHeightCalculated: false
		};
	},

	computed: {
		getRoadImageStyle() {
			if (this.containerHeightCalculated && this.containerHeight < 1600) {
				return {
					height: "85rem"
				};
			} else {
				return {
					height: "auto"
				};
			}
		}
	},

	mounted() {
		this.windowWidth = window.innerWidth;
		this.calculateContainerHeight();
		window.addEventListener("resize", this.handleResize);
	},

	beforeUnmount() {
		window.removeEventListener("resize", this.handleResize);
	},

	methods: {
		handleResize() {
			this.windowWidth = window.innerWidth;
			this.calculateContainerHeight();
		},

		calculateContainerHeight() {
			this.$nextTick(() => {
				if (this.$refs.container) {
					this.containerHeight = this.$refs.container.getBoundingClientRect().height;
					this.containerHeightCalculated = true;
				}
			});
		}
	}
};
</script>
